// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-btns[data-v-d00c4ae2] {\n  display: inline-block;\n  position: absolute;\n  right: 60px;\n  margin-top: 4px;\n  z-index: 1;\n}", ""]);
// Exports
module.exports = exports;
